import styled, { keyframes } from "styled-components";
import { paletas } from "../../../styles/theme";
import bg from "../../../assets/imagens/banners/inicio-temporada.gif";
import bg2 from "../../../assets/imagens/banners/bg-secundario-1.gif";
import bg3 from "../../../assets/imagens/banners/bg-secundario-2.gif";

const animacao = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const Wrapper = styled.section`
  position: relative;
  width: 100%;
  animation: 0.25s ${animacao};
  display: flex;
  flex-direction: column;

  .principal {
    margin-bottom: 10px;

    .card-destaque {
      min-height: 300px;
      background-image: url(${bg});
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      object-fit: cover;
      border: none;
      border-radius: 0.25rem;
      text-align: center;
      display: flex;
      justify-content: center;

      &:hover {
        transition: all 0.25s;
        background-size: 105%;
      }

      button {
        background: none;
        border: none;

        h3,
        p,
        span {
          color: ${paletas.White};
          margin-bottom: 50px;
        }

        h3 {
          span {
            color: ${paletas.RedTheme};
            font-size: 1.6rem;
          }
        }

        p {
          font-weight: bold;
          font-size: 1.5rem;

          @media (min-width: 600px) {
            font-size: 2rem;
          }

          @media (min-width: 960px) {
            font-size: 3rem;
          }
        }

        span {
          font-size: 20px;
        }
      }
    }

    h3 {
      font-size: 1.5rem;
      margin-bottom: 8px;
    }

    p {
      font-size: 1.25rem;
      line-height: 25px;
    }

    img {
      transition: all 0.25s;
      width: 100%;
      height: 30vh;
      background: rgba(255, 255, 255, 0.8);
      overflow: hidden;
      object-fit: contain;
      border-radius: 0.25rem;
      filter: brightness(0.8);

      &:hover {
        filter: brightness(1);
      }
    }
  }

  .secundario {
    margin: 0px 0px 20px;

    .card-secundario {
      background-image: url(${bg2});
    }
    .card-terceiro {
      background-image: url(${bg3});
    }

    .card-secundario,
    .card-terceiro {
      height: 200px;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      object-fit: cover;
      border: none;
      border-radius: 0.25rem;
      text-align: center;
      display: flex;
      justify-content: center;

      &:hover {
        transition: all 0.25s;
        background-size: 105%;
      }
    }

    img {
      transition: all 0.25s;
      width: 100%;
      height: 25vh;
      background: rgba(255, 255, 255, 0.8);
      overflow: hidden;
      object-fit: contain;
      border-radius: 0.25rem;
      filter: brightness(0.8);

      &:hover {
        filter: brightness(1);
      }
    }

    a {
      color: ${paletas.White};
      transition: all 0.25s;

      &:hover {
        color: ${paletas.RedTheme};
      }
    }
  }
`;
